
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.998 12.802v2.4c0 .424.164.831.456 1.131.292.3.687.469 1.1.469h10.892c.413 0 .808-.169 1.1-.469.292-.3.456-.707.456-1.131v-2.4M10 13.099l3.3-3.3m-3.3 3.3l-3.3-3.3m3.3 3.3v-9.9","stroke":"#A6ADB5","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    